import { generatePath } from "react-router";
import { ROUTES } from "../../../../routes";
import type { StepStatus } from "../../ChangeProcess.types";
import { ChangeProcessAccordionItem } from "../../components/ChangeProcessAccordionItem";
import {
  StepNewContract,
  StepStaffReviewOnly,
  StepWithMissingData
} from "../../components/ChangeSteps";
import type {
  OperatorChange,
  OperatorChangeSteps
} from "../OperatorChanges.types";

interface OperatorChangeProcessProps {
  operatorChange: OperatorChange;
  shouldShowStaffView: boolean;
  isUpdating: boolean;
  onUpdateStepStatus: (
    operatorChange: OperatorChange,
    step: keyof OperatorChangeSteps,
    status: StepStatus
  ) => void;
  projectId?: string;
}

function OperatorChangeProcess({
  operatorChange,
  isUpdating,
  onUpdateStepStatus,
  shouldShowStaffView,
  projectId
}: OperatorChangeProcessProps) {
  const stepNewData = operatorChange.steps.stepNewData;
  const stepNewContract = operatorChange.steps.stepNewContract;
  const stepOldContract = operatorChange.steps.stepOldContract;
  const stepTaskList = operatorChange.steps.stepTaskList;

  const newContractLink = projectId
    ? generatePath(ROUTES.mieterstrom.contracts, {
        projectId
      })
    : undefined;

  return (
    <ChangeProcessAccordionItem
      disabled={isUpdating}
      title={operatorChange.componentName}
      value={`operator-change-${operatorChange.id}`}
    >
      <StepWithMissingData
        isUpdating={isUpdating}
        label="Stammdaten des neuen Betreibers eintragen"
        missingData={stepNewData.missingData}
        modalLink={`betreiberwechsel/unternehmensdaten/${operatorChange.id}/`}
        status={stepNewData.done}
        onUpdateStepStatus={(status) =>
          onUpdateStepStatus(operatorChange, "stepNewData", status)
        }
      />
      <StepNewContract
        isUpdating={isUpdating}
        newContractLink={newContractLink}
        objectsAreMissing={stepNewContract.objectsAreMissing}
        status={stepNewContract.done}
        onUpdateStepStatus={(status) =>
          onUpdateStepStatus(operatorChange, "stepNewContract", status)
        }
      />
      <StepWithMissingData
        isUpdating={isUpdating}
        label="Verträge des alten Betreibers anpassen"
        missingData={stepOldContract.missingData}
        modalLink={`betreiberwechsel/vertragsdaten/${operatorChange.id}/`}
        status={stepOldContract.done}
        onUpdateStepStatus={(status) =>
          onUpdateStepStatus(operatorChange, "stepOldContract", status)
        }
      />
      <StepStaffReviewOnly
        isUpdating={isUpdating}
        label="Aufgabenliste aktualisieren"
        shouldShowStaffView={shouldShowStaffView}
        status={stepTaskList.done}
        onUpdateStepStatus={(status) =>
          onUpdateStepStatus(operatorChange, "stepTaskList", status)
        }
      />
    </ChangeProcessAccordionItem>
  );
}

export { OperatorChangeProcess, OperatorChangeProcessProps };
